import * as z from "zod/v4";

/**
 * The only notable difference between Mongo and JSON is that mongoose supports dates.
 * This helper function makes it possible to support both sources in one schema.
 */
export const dateOrStringAsDate = z
  .union([z.date(), z.string()])
  .transform((value) => (typeof value === "string" ? new Date(value) : value));

export const numberlikeSchema = z.any().transform((value) => {
  const stringVal = String(value);
  return Number(stringVal);
});

export function createEnum<E extends Record<string, string>>(enumObj: E) {
  const values = Object.values(enumObj) as [E[keyof E], ...E[keyof E][]];

  return z.enum(values, {
    // Don't need to print expected values, included in another part of the error message
    error: (iss) => {
      const input = iss.input === "" ? "<empty-string>" : String(iss.input);
      return `Received ${input}`;
    },
  });
}
